import { DownChevron } from '@/assets'
import { Container, Typography } from '@cleartrip/ct-design-components'
import Image from 'next/image'
import styles from './style.module.scss'

interface EmiBankCalloutProps {
    imgUrl: string
    heading: string
    subheading: string
    isNoCost: boolean
    onClick: any
    isOpen: boolean
}

const EmiBankCallout = ({ imgUrl, heading, subheading, isNoCost, onClick, isOpen }: EmiBankCalloutProps) => {
    return (
        <Container
            className="flex flex-middle flex-between p-4 c-pointer emiBankList"
            style={{ borderTop: '1px solid #E0E0E0' }}
            onClick={onClick}
        >
            <Container className="flex " style={{ gap: '16px' }}>
                <Container>
                    <Image width={32} height={32} src={imgUrl} alt={''} />
                </Container>
                <Container className="flex flex-column " style={{ gap: '4px' }}>
                    <Typography variant="HM3">{heading}</Typography>
                    <Typography variant="B2" color={isNoCost ? 'success' : 'subheading'}>
                        {subheading}
                    </Typography>
                </Container>
            </Container>
            <Container style={{ rotate: isOpen ? '180deg' : '' }}>
                <DownChevron height={'16px'} width={'16px'} />
            </Container>
        </Container>
    )
}

export default EmiBankCallout
